<template lang="pug">
  - $image_path = '@/assets/images/game/status/';
  ul.life-list(ref="list")
    li.life-list-item.is-on(v-for="n of maxLife" ref="item")
      .icon-animation.heart-up(data-key="heartUp" :data-index="n")
      .icon-animation.heart-down(data-key="heartDown" :data-index="n")
      .icon-image.heart-on: img(src=`${$image_path}image_life_point_on.png`)
      .icon-image.heart-off: img(src=`${$image_path}image_life_point_off.png`)
</template>

<script>
import _ from 'lodash';
import lottie from 'lottie-web';
import { mapState } from 'vuex';

import SoundController from '@/assets/js/SoundController';
import Utils from '@/assets/js/Utils';
import PreloadAnimation from '@/assets/js/data/preloadAnimation';
import GameManager from '@/assets/js/game/GameManager';

export default {
  name: 'Life',
  data() {
    return {
      counter: GameManager.maxLife,
      animationList: {}
    };
  },
  computed: {
    ...mapState(['life']),
    maxLife() {
      return GameManager.maxLife;
    }
  },
  beforeDestroy() {
    SoundController.stopAll();
  },
  methods: {
    reset() {
      this.counter = this.maxLife;
      _.forEach(this.$refs.item, item => {
        item.classList.remove('is-off');
        item.classList.add('is-on');
      });
    },
    load() {
      const items = this.$refs.list.getElementsByClassName('icon-animation');
      return Promise.all(
        _.map(items, (target, index) => {
          return this.loadItem(target);
        })
      );
    },
    loadItem(target) {
      const key = target.dataset.key;
      const index = parseInt(target.dataset.index) - 1;
      return PreloadAnimation.load(target, key).then(
        ({ bodymovin, element, key }) => {
          if (!this.animationList[key]) this.animationList[key] = [];
          this.animationList[key][index] = {
            parent: element.parentNode,
            element: element,
            bodymovin: bodymovin
          };

          bodymovin.addEventListener('complete', () => {
            this.complete(key, element, bodymovin);
          });
        }
      );
    },
    up() {
      this.stopAll();

      SoundController.play('se_player_cure_heart');
      this.play('heartUp', this.counter);

      this.counter++;
      if (this.counter > this.maxLife) this.counter = this.maxLife;
    },
    down() {
      this.stopAll();

      this.counter--;
      if (this.counter < 0) this.counter = 0;
      this.getTarget(
        'heartDown',
        this.counter
      ).element.parentNode.classList.remove('is-on');
      this.play('heartDown', this.counter);
    },
    play(key, index) {
      const target = this.getTarget(key, index);
      target.element.classList.add('is-animation');
      target.bodymovin.goToAndPlay(0);
    },
    getTarget(key, index) {
      return this.animationList[key][index];
    },
    stopAll() {
      _.forEach(this.animationList, (items, key) => {
        _.forEach(items, target => {
          target.bodymovin.goToAndStop(0);
          if (!target.bodymovin.isPaused) {
            this.complete(key, target.element, target.bodymovin);
          }
        });
      });

      _.forEach(this.$refs.item, (item, index) => {
        if (this.counter - 1 >= index) {
          item.classList.remove('is-off');
          item.classList.add('is-on');
        }
      });
    },
    complete(key, element, bodymovin) {
      element.classList.remove('is-animation');
      bodymovin.goToAndStop(0);
      const parentElement = element.parentNode;

      if (key === 'heartUp') {
        parentElement.classList.remove('is-off');
        parentElement.classList.add('is-on');
      }

      if (key === 'heartDown') {
        parentElement.classList.add('is-off');
        parentElement.classList.remove('is-on');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.life-list {
  display: flex;
  position: absolute;
  top: vw(75);
  left: vw(540);
  z-index: 1;
  &-item {
    position: relative;
    width: vw(160);
    height: vw(160);
    margin-left: vw(-40);
    &:first-child {
      margin-left: 0;
    }
    &.is-on {
      .heart-on {
        opacity: 1;
      }
      .heart-off {
        opacity: 0;
      }
    }
    &.is-off {
      .heart-on {
        opacity: 0;
      }
      .heart-off {
        opacity: 1;
      }
    }
  }
  .icon-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    &.heart-up {
      z-index: 3;
    }
    &.heart-down {
      z-index: 2;
    }
    &.is-animation {
      opacity: 1;
    }
  }
  .icon-image {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    &.heart-on {
      z-index: 1;
    }
    &.heart-off {
      z-index: 0;
    }
  }
}
</style>
